<template>
  <Paper class="tenant-config">
    <searchTenant @closeChange="searchCode" ref="search" :searchBlock='searchBlock' class="tenant-config-search"></searchTenant>
    <div class="tenant-config-table">
        <tableTenant :tableData="tableData" ></tableTenant>
    </div>
    <div class="tenant-config-add">
        <el-button @click="newPush" icon="el-icon-plus" type="primary" size="mini" class="new-button">
            {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
        </el-button>
    </div>
    <pageList
        v-if="pageState"
        :pageMenu="pageMenu"
        @changeCurrent="currentDom"
        @changeSize="sizeDom"
        class="tenant-config-page">
    </pageList>
<!-- 新增 -->
    <el-dialog
        :title="$translate('lang.E3202103150006', { defaultText: '租户新增' })"
        :visible.sync="added"
        width="450px"
        :before-close="clearCheck"
        class="tenant-config-main"
        >
        <el-form :inline="true" :model="lessee" class="demo-form-inline" ref="lessee" :rules="rules" label-width="120px">
            <el-form-item :label="$translate('lang.E3202103110001', { defaultText: '租户代码' })" prop="tenantCode">
                <el-select class="tenant-config-main-item" v-model="lessee.tenantCode"  @change="setTenantName">
                    <el-option
                        v-for="item in tenantList"
                        :key="item.tenantCode"
                        :label="item.tenantCode"
                        :value="item.tenantCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$translate('lang.E3202103110002', { defaultText: '租户名称' })" prop="tenantName">
                <el-input class="tenant-config-main-item" v-model="lessee.tenantName" disabled ></el-input>
            </el-form-item>
            <el-form-item :label="$translate('lang.E3202103150005', { defaultText: '集群选择' })" prop="esClusterId">
                <el-select class="tenant-config-main-item" v-model="lessee.esClusterId" >
                    <el-option
                        v-for="item in colonyList"
                        :key="item.id"
                        :label="item.clusterName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="clearCheck"  class="system-management-cancel-button" size="mini">
                {{$translate('lang.E3202101270002', { defaultText: '取消' })}}
            </el-button>
            <el-button type="primary" @click="addTenant" class="system-management-confirm-button" size="mini">
                {{$translate('lang.E3202101270001', { defaultText: '确定' })}}
            </el-button>
        </span>
    </el-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import pageList from '../../../components/systemComponent/pageList';
import searchTenant from './search';
import tableTenant from './table';
import { getTenant, newQuota, getESIndex, tenantList } from '../../../api/systemManagementApi';
export default {
    name: 'tenant',
    data() {
        return {
            pageState: true,
            searchBlock: false,
            lessee: {
                tenantCode: '',
                tenantName: '',
                esClusterId: ''
            },
            colonyList: [],
            added: false,
            esClusterId: '',
            tenantName: '',
            condition: '',
            dialogUser: false,
            tenantList: [],
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            },
            tableData: [],
            pushNew: [],
            rules: {
                tenantCode: [{ required: true, message: this.$translate('lang.E3202103150001', { defaultText: '请选择租户代码' }), trigger: 'change' }],
                tenantName: [{ required: true, message: this.$translate('lang.E3202103150002', { defaultText: '请输入租户名称' }), trigger: 'blur' }],
                esClusterId: [{ required: true, message: this.$translate('lang.E3202103150003', { defaultText: '请选择绑定集群' }), trigger: 'change' }]
            }
        };
    },
    components: {
        searchTenant,
        pageList,
        tableTenant,
        Paper
    },
    methods: {
        setTenantName(value) {
            this.tenantList.map(item => {
                if (item.tenantCode === value) {
                    this.lessee.tenantName = item.tenantName;
                }
            });
        },
        // 清楚校验
        clearCheck() {
            this.$refs.lessee.resetFields();
            this.added = false;
        },
        // 点击确定，进行新增租户添加
        addTenant() {
            this.$refs.lessee.validate((valid) => {
                if (valid) {
                    newQuota([{ esClusterId: this.lessee.esClusterId, tenantCode: this.lessee.tenantCode, operateType: 'NEW' }]).then(res => {
                        if (res.code === '0') {
                            this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '保存成功' }));
                            this.added = false;
                            this.getInf();
                            this.$refs.lessee.resetFields();
                        }
                    });
                }
            });
        },
        // 新增页面
        newPush() {
            this.lessee.tenantCode = null;
            this.lessee.tenantName = null;
            this.lessee.esClusterId = null;
            this.added = true;
        },
        // 分页1
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.getInf();
        },
        // 分页2
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.getInf();
        },
        // 搜索
        searchCode(value) {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.getInf();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        handleLogin() {
            if (this.tenantName.trim()) {
                this.tenantName = '';
            } else {
                this.$message.error(this.$translate('lang.EXC202103150001', { defaultText: '不能为空' }));
                this.tenantName = '';
            }
        },
        getInf() {
            getTenant({
                tenantCodeCondi: this.$refs.search.queries.tenantCode,
                tenantName: this.$refs.search.queries.tenantName,
                clusterName: this.$refs.search.queries.colony,
                pageNo: this.pageMenu.pageNo,
                pageSize: this.pageMenu.pageSize
            }).then(res => {
                this.tableData = res.data.list;
                this.pageMenu.totalCount = res.data.totalCount;
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        }
    },
    created() {
        getESIndex({}).then(res => {
            this.colonyList = res.data.list;
        });
        tenantList(1).then(res => {
            this.tenantList = res.data;
        });
    },
    mounted() {
        this.getInf();
    }
};
</script>
<style lang="less">
.tenant-config{
.tenant-config-table{
    .el-table {
        height: calc(100vh - 180px) !important;
    }
    .row-bg {
    margin-top: 20px;
    }
}
.tenant-config-add{
    float: left;
    margin-top: 20px;
}
.tenant-config-page{
    margin-top: 20px;
    text-align: right;
}
.tenant-config-main{
    .el-form-item__label{
            padding: 0 10px 0 0;
    }
}
.tenant-config-main-item{
    width: 244px;
}
.el-form-item{
    margin-right: 0;
}

}

</style>